import { v4 as uuidv4 } from "uuid";


function gererateUuid(): string {
    return uuidv4();
};

export default gererateUuid;